<section class="footer pull-left w-100">
    <div class="container">
      <div class="row">
        <div class="wrapper footer-wrapper">

            <footer class="">
              <div class="row">

                <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12 col- footer-left">
                  <!-- Mobile Nav -->
                  <nav class="pull-left w-100 d-none d-xl-block">
                    <ul class="font-size3 oriya-color1 list-none padding-left-0 margin-bottom-30 pull-left w-100">
                      <li><a class="aboutgap staticroutes padding-bottom-10" href="/about-us" routerLink="/about-us">About Us</a></li>
                      <!-- <li><a class="staticroutes padding-bottom-10" routerLink="/faq">FAQ's</a></li> -->
                      <!-- <li><a class="staticroutes padding-bottom-10">FAQ's</a></li> -->
                      <li><a href="/terms_and_conditions" routerLink="/terms_and_conditions" class="staticroutes padding-bottom-10">Terms Of Use</a></li>
                      <li><a href="/privacy_policy" routerLink="/privacy_policy" class="staticroutes padding-bottom-10">Privacy Policy</a></li>
                      <li><a href="/contact-us" routerLink="/contact-us" class="staticroutes padding-bottom-10">Contact us</a></li>
                      <li><a href="/refund_policy" routerLink="/refund_policy" class="staticroutes padding-bottom-10">Refund Policy</a></li>
                       <li><a href="/digital-delivery-exchange" routerLink="/digital-delivery-exchange" class="staticroutes padding-bottom-10">Digital Delivery Exchange</a></li>
                    </ul>
                  </nav>

                  <nav class="pull-left w-100 d-block d-xl-none"> <!-- Website Nav -->
                    <ul class="list-none padding-left-0 margin-bottom-25 pull-left w-100">
                      <li><a (click)="newWindowRoutes('about-us')" class="staticroutes">About Us</a></li>
                      <!-- <li><a (click)="newWindowRoutes('faq')" class="staticroutes">FAQ's</a></li> -->
                      <li><a (click)="newWindowRoutes('terms_and_conditions')" class="staticroutes">Terms Of Use</a></li>
                      <li><a (click)="newWindowRoutes('privacy_policy')" class="staticroutes">Privacy Policy</a></li>
                      <li><a (click)="newWindowRoutes('contact-us')" class="staticroutes">Contact us</a></li>
                      <li><a (click)="newWindowRoutes('refund_policy')" class="staticroutes">Refund Policy</a></li>
                    </ul>
                  </nav>
                  <p class="footer-desc oriya-color2 d-none d-xl-block  pull-left">
                    Tarang Plus © 2026, All Rights Reserved
                  </p>
                </div>
                <div class="footer-right">
                  <div class="pull-left social_icons">
                    <p class="margin-bottom-30">Connect With Us</p>
                    <span>
                    <a (click)="externalRedirect('https://www.instagram.com/tarangplusodisha/', 'Instagram')" target="_blank">
                      <img src="./assets/tarangplus/instagram.svg" alt="Instagram" title="Instagram">
                      <img class="hover" src="./assets/tarangplus/instagram_hover.svg" alt="Instagram" title="Instagram">
                    </a>
                  </span>
                    <a (click)="externalRedirect('https://www.facebook.com/tarangplus', 'Facebook')" target="_blank">
                      <img src="./assets/tarangplus/facebook.svg" alt="Facebook" title="Facebook">
                      <img class="hover" src="./assets/tarangplus/facebook_hover.svg" alt="Facebook" title="Facebook">
                    </a>
                    <a (click)="externalRedirect('https://x.com/tarangplusodia', 'Twitter')" target="_blank">
                      <img src="./assets/tarangplus/icon_default_twitter.svg" alt="Twitter" title="Twitter">
                      <img class="hover" src="./assets/tarangplus/icon_default_twitter-1.svg" alt="Twitter" title="Twitter">
                    </a>
                    <a (click)="externalRedirect('https://www.youtube.com/channel/UCujyiVE2bbQwzkQX-nGI1yQ', 'Youtube')" target="_blank">
                      <img src="./assets/tarangplus/icon_default_youTube.svg" alt="Youtube" title="Youtube">
                      <img class="hover" src="./assets/tarangplus/icon_default_youTube-1.svg" alt="Youtube" title="Youtube">
                    </a>
                    
                  </div>
                  <div class="">
                    <p class="margin-bottom-30 margin-left-0 font-size3">Tarang App</p>
                    <div class="footer-icons"> 
                      <!-- <a href="https://play.google.com/store/apps/details?id=com.tarangplus.tv&pli=1" target="_blank"> -->
                        <a href="https://play.google.com/store/apps/details?id=com.otl.tarangplus" target="_blank">
                        <img src="./assets/tarangplus/icon_playStore.svg" alt="Android App" title="Android App">
                       
                        <img  class="hover" src="./assets/tarangplus/icon_playStore_hover.svg" alt="Android App" title="Android App">
                      </a>
                       <a href="https://apps.apple.com/us/app/tarangplus/id1478384536" target="_blank"> 
                        <img src="./assets/tarangplus/icon_appStore.svg" alt=" App Store" title=" App Store">
                        <img class="hover" src="./assets/tarangplus/icon_appStore_hover.svg" alt=" App Store" title=" App Store">
                      </a>
                      <!-- <a>
                        <img src="./assets/tarangplus/icon_tizen.svg" alt="Tizen App" title="Tizen ">
                        <img class="hover" src="./assets/tarangplus/icon_tizen_hover.svg" alt="Tizen App" title="Tizen ">
                      </a> -->
                      <!-- <a>
                        <img src="./assets/tarangplus/icon_fireTV.svg"alt="Fire TV App " title="Fire TV App">
                        <img class="hover" src="./assets/tarangplus/icon_fireTV_hover.svg"alt="Fire TV App " title="Fire TV App">
                      </a> -->

                      <!-- <a>
                        <img src="./assets/tarangplus/icon_androidTV.svg" alt="Android TV app" title="Android TV App">
                        <img class="hover" src="./assets/tarangplus/icon_androidTV.svg"  alt="Android TV app" title="Android TV App">
                      </a> -->
                    </div>
                  </div>
                </div>

              </div>

            </footer>

        </div>
      </div>
    </div>
    </section>

